export default {
    disclaimer: {
        label_default: "Ich bestätige und stimme zu, dass die von mir bestellten/erhaltenen Gegenstände Eigentum von O-I sind und für arbeitsbezogene Tätigkeiten von O-I verwendet werden dürfen. Daher behält sich O-I das Recht vor, die Rückgabe des Eigentums bei meinem Ausscheiden aus O-I (oder früher, falls von O-I gefordert) zu verlangen.",
        label_type_1: "Ich bestätige, dass die Selbsteinschätzung für die Heimarbeit korrekt und nach bestem Wissen und Gewissen ausgefüllt wurde und dass jegliche Ausrüstung oder Möbel, die mir von O-I zur Verfügung gestellt oder über Gear bestellt werden, von mir ausschließlich für meine Tätigkeit bei O-I verwendet werden. Ich erkenne an und stimme zu, dass die von mir bestellten/erhaltenen Gegenstände Eigentum von O-I sind und für arbeitsbezogene Tätigkeiten von O-I verwendet werden dürfen. Daher behält sich O-I das Recht vor, die Rückgabe des Eigentums bei meinem Ausscheiden aus dem Unternehmen (oder gegebenenfalls früher) zu verlangen.",
        errors: {
            required: "Bitte akzeptieren Sie die Nutzungsbedingungen"
        }
    },
    cost_center: {
        label: "Kostenstellencode",
        placeholder: "Kostenstellencode",
        cost_center_not_found: "Nicht aufgeführte Kostenstellen können bis zu 24 Stunden benötigen, um angezeigt zu werden. Wenden Sie sich an den Global Service Desk, falls die entsprechende Kostenstelle nicht angezeigt wird.",
        errors: {
            regex: "Ungültiger Kostenstellencode"
        }
    },
    company_code: {
        label: "Firmencode"
    },
    cost_center_name: {
        label: "Name des Kostenstellens"
    },
    order_note: {
        label: "Bestellhinweis",
        placeholder: "Optionaler Hinweis an den Manager zur Genehmigung",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Benachrichtigen Sie mich bitte über Aktualisierungen zu dieser Bestellung"
    },
    "dell_banner":{
        label: "Aufgrund von Systemaktualisierungen bei Dell kann es bei Bestellungen, die zwischen dem 1. und 14. August 2026 eingehen, zu erheblichen Verzögerungen bei der Bearbeitung kommen. Bitte rechnen Sie in diesem Zeitraum mit längeren Lieferzeiten. Vielen Dank für Ihr Verständnis."
    }
}